/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ControllingProjectDetails } from '../models/ControllingProjectDetails';
import type { ControllingProjectFilterOptions } from '../models/ControllingProjectFilterOptions';
import type { ControllingProjectsExportStatus } from '../models/ControllingProjectsExportStatus';
import type { ControllingProjectTotals } from '../models/ControllingProjectTotals';
import type { PaginatedControllingProjectOverviews } from '../models/PaginatedControllingProjectOverviews';
import type { SyncStatus } from '../models/SyncStatus';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingProjectsService {
    /**
     * lists paginated projects
     * @param tenantId tenant_id
     * @param costView cost view
     * @param numbersArray project numbers
     * @param costObjectNumbersArray cost object numbers
     * @param withToolCostCenters with_tool_cost_centers
     * @param businessLinesArray business lines
     * @param businessLinesDataflorArray business lines dataflor
     * @param serviceCategoriesArray service categories
     * @param serviceCategoriesOrderManagementArray service categories of order management
     * @param serviceCategoriesDataflorArray service categories dataflor
     * @param managerStaffNumbersArray manager staff numbers
     * @param searchText search_text
     * @param statusArray filter status
     * @param clientNamesArray client names
     * @param startDate start_date
     * @param endDate end_date
     * @param page page
     * @param sortBy sort_by
     * @param direction
     * @param tenantIdsArray tenant ids to filter by (requires the tenant filter ability)
     * @returns PaginatedControllingProjectOverviews successful when is cost view (not result view)
     * @throws ApiError
     */
    public static getProjectOverviews(
        tenantId: string,
        costView: boolean,
        numbersArray?: Array<string>,
        costObjectNumbersArray?: Array<string>,
        withToolCostCenters?: boolean,
        businessLinesArray?: Array<string>,
        businessLinesDataflorArray?: Array<string>,
        serviceCategoriesArray?: Array<string>,
        serviceCategoriesOrderManagementArray?: Array<string>,
        serviceCategoriesDataflorArray?: Array<string>,
        managerStaffNumbersArray?: Array<string>,
        searchText?: string,
        statusArray?: Array<'completed' | 'in_progress' | 'unstarted' | 'archived' | 'unknown'>,
        clientNamesArray?: Array<string>,
        startDate?: string,
        endDate?: string,
        page?: number,
        sortBy?: 'number' | 'actual_costs_total' | 'target_costs_total' | 'actual_productive_hours_total' | 'target_productive_hours_total' | 'actual_profit_contribution' | 'target_profit_contribution' | 'actual_profit_contribution_per_hour' | 'target_profit_contribution_per_hour' | 'actual_profit_contribution_percentage' | 'target_profit_contribution_percentage' | 'actual_relative_profit_contribution' | 'target_relative_profit_contribution' | 'actual_revenue_total' | 'target_revenue_total' | 'last_incoming_invoice_at' | 'last_outgoing_invoice_at' | 'minimum_invoice_amount' | 'actual_costs_wages' | 'target_costs_wages' | 'actual_costs_tools' | 'target_costs_tools' | 'actual_costs_materials' | 'target_costs_materials' | 'actual_costs_misc' | 'target_costs_misc' | 'actual_costs_plants' | 'target_costs_plants' | 'actual_costs_foreign' | 'target_costs_foreign' | 'actual_costs_disposal' | 'target_costs_disposal' | 'actual_costs_overheads' | 'target_costs_overheads',
        direction?: 'asc' | 'desc',
        tenantIdsArray?: Array<string>,
    ): CancelablePromise<PaginatedControllingProjectOverviews> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/overviews',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'numbers[]': numbersArray,
                'cost_object_numbers[]': costObjectNumbersArray,
                'with_tool_cost_centers': withToolCostCenters,
                'business_lines[]': businessLinesArray,
                'business_lines_dataflor[]': businessLinesDataflorArray,
                'service_categories[]': serviceCategoriesArray,
                'service_categories_order_management[]': serviceCategoriesOrderManagementArray,
                'service_categories_dataflor[]': serviceCategoriesDataflorArray,
                'manager_staff_numbers[]': managerStaffNumbersArray,
                'search_text': searchText,
                'status[]': statusArray,
                'client_names[]': clientNamesArray,
                'start_date': startDate,
                'end_date': endDate,
                'page': page,
                'sort_by': sortBy,
                'direction': direction,
                'tenant_ids[]': tenantIdsArray,
                'cost_view': costView,
            },
        });
    }
    /**
     * returns all available filter options for the current result
     * @param tenantId tenant_id
     * @param numbersArray project numbers
     * @param costObjectNumbersArray cost object numbers
     * @param withToolCostCenters with_tool_cost_centers
     * @param businessLinesArray business lines
     * @param businessLinesDataflorArray business lines dataflor
     * @param serviceCategoriesArray service categories
     * @param serviceCategoriesOrderManagementArray service categories of order management
     * @param serviceCategoriesDataflorArray service categories dataflor
     * @param managerStaffNumbersArray manager staff numbers
     * @param statusArray filter status
     * @param clientNamesArray client names
     * @param startDate start_date
     * @param endDate end_date
     * @param tenantIdsArray tenant ids to filter by (requires the tenant filter ability)
     * @returns ControllingProjectFilterOptions successful
     * @throws ApiError
     */
    public static getProjectFilterOptions(
        tenantId: string,
        numbersArray?: Array<string>,
        costObjectNumbersArray?: Array<string>,
        withToolCostCenters?: boolean,
        businessLinesArray?: Array<string>,
        businessLinesDataflorArray?: Array<string>,
        serviceCategoriesArray?: Array<string>,
        serviceCategoriesOrderManagementArray?: Array<string>,
        serviceCategoriesDataflorArray?: Array<string>,
        managerStaffNumbersArray?: Array<string>,
        statusArray?: Array<'completed' | 'in_progress' | 'unstarted' | 'archived' | 'unknown'>,
        clientNamesArray?: Array<string>,
        startDate?: string,
        endDate?: string,
        tenantIdsArray?: Array<string>,
    ): CancelablePromise<ControllingProjectFilterOptions> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/filter_options',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'numbers[]': numbersArray,
                'cost_object_numbers[]': costObjectNumbersArray,
                'with_tool_cost_centers': withToolCostCenters,
                'business_lines[]': businessLinesArray,
                'business_lines_dataflor[]': businessLinesDataflorArray,
                'service_categories[]': serviceCategoriesArray,
                'service_categories_order_management[]': serviceCategoriesOrderManagementArray,
                'service_categories_dataflor[]': serviceCategoriesDataflorArray,
                'manager_staff_numbers[]': managerStaffNumbersArray,
                'status[]': statusArray,
                'client_names[]': clientNamesArray,
                'start_date': startDate,
                'end_date': endDate,
                'tenant_ids[]': tenantIdsArray,
            },
        });
    }
    /**
     * lists project totals
     * @param tenantId tenant_id
     * @param costView cost view
     * @param numbersArray project numbers
     * @param costObjectNumbersArray cost object numbers
     * @param withToolCostCenters with_tool_cost_centers
     * @param businessLinesArray business lines
     * @param businessLinesDataflorArray business lines dataflor
     * @param serviceCategoriesArray service categories
     * @param serviceCategoriesOrderManagementArray service categories of order management
     * @param serviceCategoriesDataflorArray service categories dataflor
     * @param managerStaffNumbersArray manager staff numbers
     * @param searchText search_text
     * @param statusArray filter status
     * @param clientNamesArray client names
     * @param startDate start_date
     * @param endDate end_date
     * @param tenantIdsArray tenant ids to filter by (requires the tenant filter ability)
     * @returns ControllingProjectTotals successful
     * @throws ApiError
     */
    public static getProjectTotals(
        tenantId: string,
        costView: boolean,
        numbersArray?: Array<string>,
        costObjectNumbersArray?: Array<string>,
        withToolCostCenters?: boolean,
        businessLinesArray?: Array<string>,
        businessLinesDataflorArray?: Array<string>,
        serviceCategoriesArray?: Array<string>,
        serviceCategoriesOrderManagementArray?: Array<string>,
        serviceCategoriesDataflorArray?: Array<string>,
        managerStaffNumbersArray?: Array<string>,
        searchText?: string,
        statusArray?: Array<'completed' | 'in_progress' | 'unstarted' | 'archived' | 'unknown'>,
        clientNamesArray?: Array<string>,
        startDate?: string,
        endDate?: string,
        tenantIdsArray?: Array<string>,
    ): CancelablePromise<ControllingProjectTotals> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/totals',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'numbers[]': numbersArray,
                'cost_object_numbers[]': costObjectNumbersArray,
                'with_tool_cost_centers': withToolCostCenters,
                'business_lines[]': businessLinesArray,
                'business_lines_dataflor[]': businessLinesDataflorArray,
                'service_categories[]': serviceCategoriesArray,
                'service_categories_order_management[]': serviceCategoriesOrderManagementArray,
                'service_categories_dataflor[]': serviceCategoriesDataflorArray,
                'manager_staff_numbers[]': managerStaffNumbersArray,
                'search_text': searchText,
                'status[]': statusArray,
                'client_names[]': clientNamesArray,
                'start_date': startDate,
                'end_date': endDate,
                'tenant_ids[]': tenantIdsArray,
                'cost_view': costView,
            },
        });
    }
    /**
     * start generating csv of selected projects
     * @param tenantId tenant_id
     * @param numbersArray project numbers
     * @param costObjectNumbersArray cost object numbers
     * @param withToolCostCenters with_tool_cost_centers
     * @param businessLinesArray business lines
     * @param businessLinesDataflorArray business lines dataflor
     * @param serviceCategoriesArray service categories
     * @param serviceCategoriesOrderManagementArray service categories of order management
     * @param serviceCategoriesDataflorArray service categories of dataflor
     * @param managerStaffNumbersArray manager staff numbers
     * @param statusArray filter status
     * @param clientNamesArray client names
     * @param startDate start_date
     * @param endDate end_date
     * @param tenantIdsArray tenant ids to filter by (requires the tenant filter ability)
     * @returns any start generating csv
     * @throws ApiError
     */
    public static startProjectsExport(
        tenantId: string,
        numbersArray?: Array<string>,
        costObjectNumbersArray?: Array<string>,
        withToolCostCenters?: boolean,
        businessLinesArray?: Array<string>,
        businessLinesDataflorArray?: Array<string>,
        serviceCategoriesArray?: Array<string>,
        serviceCategoriesOrderManagementArray?: Array<string>,
        serviceCategoriesDataflorArray?: Array<string>,
        managerStaffNumbersArray?: Array<string>,
        statusArray?: Array<'completed' | 'in_progress' | 'unstarted' | 'archived' | 'unknown'>,
        clientNamesArray?: Array<string>,
        startDate?: string,
        endDate?: string,
        tenantIdsArray?: Array<string>,
    ): CancelablePromise<{
        export_id: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/controlling/projects/export/start',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'numbers[]': numbersArray,
                'cost_object_numbers[]': costObjectNumbersArray,
                'with_tool_cost_centers': withToolCostCenters,
                'business_lines[]': businessLinesArray,
                'business_lines_dataflor[]': businessLinesDataflorArray,
                'service_categories[]': serviceCategoriesArray,
                'service_categories_order_management[]': serviceCategoriesOrderManagementArray,
                'service_categories_dataflor[]': serviceCategoriesDataflorArray,
                'manager_staff_numbers[]': managerStaffNumbersArray,
                'status[]': statusArray,
                'client_names[]': clientNamesArray,
                'start_date': startDate,
                'end_date': endDate,
                'tenant_ids[]': tenantIdsArray,
            },
        });
    }
    /**
     * get csv of selected projects
     * @param tenantId tenant_id
     * @param exportId export_id
     * @returns ControllingProjectsExportStatus successfully exports project data
     * @throws ApiError
     */
    public static getProjectsExportStatus(
        tenantId: string,
        exportId?: string,
    ): CancelablePromise<ControllingProjectsExportStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/export/status',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'export_id': exportId,
            },
        });
    }
    /**
     * returns the project details
     * @param tenantId tenant_id
     * @param id id
     * @param startDate start_date
     * @param endDate end_date
     * @param costObjectNumbersArray cost object numbers
     * @returns ControllingProjectDetails successful
     * @throws ApiError
     */
    public static getProjectDetails(
        tenantId: string,
        id: string,
        startDate?: string,
        endDate?: string,
        costObjectNumbersArray?: Array<string>,
    ): CancelablePromise<ControllingProjectDetails> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/{id}',
            path: {
                'tenant_id': tenantId,
                'id': id,
            },
            query: {
                'start_date': startDate,
                'end_date': endDate,
                'cost_object_numbers[]': costObjectNumbersArray,
            },
        });
    }
    /**
     * sync all projects of the current tenant
     * @param tenantId tenant_id
     * @returns void
     * @throws ApiError
     */
    public static syncControllingData(
        tenantId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/controlling/projects/sync',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
    /**
     * get status of construction sites sync
     * @param tenantId tenant_id
     * @returns SyncStatus sync status
     * @throws ApiError
     */
    public static getControllingDataSyncStatus(
        tenantId: string,
    ): CancelablePromise<SyncStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/sync_status',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
    /**
     * sync single projects of the current tenant
     * @param tenantId tenant_id
     * @param projectIdsArray project_ids
     * @returns void
     * @throws ApiError
     */
    public static syncControllingDataOfSingleProjects(
        tenantId: string,
        projectIdsArray?: Array<string>,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/controlling/projects/sync_projects',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'project_ids[]': projectIdsArray,
            },
        });
    }
    /**
     * start generating csv of missing project numbers
     * @param tenantId tenant_id
     * @returns any start generating csv
     * @throws ApiError
     */
    public static startMissingProjectNumbersExport(
        tenantId: string,
    ): CancelablePromise<{
        export_id: string;
    }> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/tenants/{tenant_id}/controlling/projects/missing_project_numbers_export/start',
            path: {
                'tenant_id': tenantId,
            },
        });
    }
    /**
     * get csv of export id
     * @param tenantId tenant_id
     * @param exportId export_id
     * @returns ControllingProjectsExportStatus successfully exports data
     * @throws ApiError
     */
    public static getMissingProjectNumbersExportStatus(
        tenantId: string,
        exportId?: string,
    ): CancelablePromise<ControllingProjectsExportStatus> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/projects/missing_project_numbers_export/status',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'export_id': exportId,
            },
        });
    }
}
